import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(flagActividad,objFile,codColaborador,obsDocumento) {
    
  const varPersona = [];
  codColaborador.map(Rows => (
    varPersona.push(Rows.id)
  ));

    const data =  {
      codColaborador: varPersona,
      codFiveAdj: '',
      codTipoAdj: objFile.tipo,
      codUsuario: IDUSUARIO,
      indInactivo: 'N',
      nomAdj: objFile.nombre,
      numFichaVtaVeh:  objFile.fdvID,
      txtRutaFire: objFile.url,
      labelTipo : objFile.labelTipo,
      obsDocumento : obsDocumento.replace(/\n/g, "<br />"),
      numPedidoVeh: objFile.placa // <90249> ivelasquez 12/03/2021
    };
    
    const config = {
        headers: {
          idUsuario: IDUSUARIO,
        },  
      };
      
      return  customAxios.post(`${FDV_URL}/archivoAdjunto/fichas-venta/${flagActividad}/adjuntar`,data,config );
      
    }


// WEBPACK FOOTER //
// ./src/utils/addAdjuntos.js